/**
 * Created by calhosh on 7/13/2017.
 */
import React from 'react';
import styled from 'styled-components';
import MotifFormField from '@ey/motif-react-wrapper/FormField';
import MotifSearch from '@ey/motif-react-wrapper/Search';

export default function EYMotifSearch(props) {
	const {
		value,
		placeholder,
		onChange,
		onKeyDown,
		onSearchButtonClick,
		onClear,
		onEnter,
		styleName,
		darkBg,
		clearHoverText,
		searchHoverText,
		hideClearButton,
		items,
		maxLength
	} = props;
	return (
		<Wrapper className={`${styleName} ${darkBg ? 'darkBgSearch' : ''}`}>
			<MotifFormField>
				<MotifSearch
					aria-label="Search"
					value={value}
					placeholder={placeholder}
					items={items}
					onChange={onChange}
					onClear={onClear}
					onKeyDown={onKeyDown}
					onEnter={onEnter}
					onSearchButtonClick={onSearchButtonClick}
					clearButtonTitle={clearHoverText}
					searchButtonTitle={searchHoverText}
					hideClearButton={hideClearButton}
					maxLength={maxLength}
				/>
			</MotifFormField>
		</Wrapper>
	);
}

const Wrapper = styled.section``;
